import { Component, Prop, Vue } from 'vue-property-decorator';
import FormValidationGuard from '@/components/forms/FormValidationGuard.vue';
import RadioGroup from '@/components/forms/RadioGroup.vue';
@Component({
    name: 'MembershipLevel',
    components: { FormValidationGuard, RadioGroup },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    value;
    @Prop({ required: true })
    ticketGroups;
    @Prop()
    heading;
    get selected() {
        return this.value;
    }
    set selected(value) {
        this.$emit('input', value);
    }
    created() {
        // Auto select if there's only one option
        if (this.levels.length === 1) {
            this.selected = this.levels[0].value;
        }
    }
    get levels() {
        return this.ticketGroups
            .filter((group) => group.handler === 'membership')
            .map((group) => ({
            value: group.id,
            label: group.name,
            price: group.price,
            originalPrice: group.originalPrice,
            description: group.description,
            summary: group.summary,
        }));
    }
    get label() {
        if (this.heading) {
            return this.heading.label;
        }
        else {
            return this.$t('membershipLevel.membershipLevel');
        }
    }
    get caption() {
        return this.heading?.description;
    }
}
